import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { CueProgram, Program } from 'globals/store/programs.data';

@Pipe({
    name: 'programDayDate',
    standalone: true
})
export class ProgramDayDate implements PipeTransform {
  transform(program: Program | CueProgram, day: number = 1, abbreviatedDay = false): string {
    if (day === undefined || day === null || !program) return ''
    if (!program.date) return `Day ${ day < 1 ? day - 1 : day}`
    const nextDay = new Date(program.date);
    nextDay.setDate(new Date(program.date).getDate() + (day - 1))
    return formatDate(nextDay, `${abbreviatedDay ? '' : 'EE'}EE d MMMM y`, 'en-au')
  }
}